export enum FileType {
    pdf = "pdf",
    word = "word",
    udf = "udf"
}
